// extracted by mini-css-extract-plugin
export var emptyState = "_5f-d";
export var statCard = "_5f-c";
export var table = "_5f-0";
export var tableCell = "_5f-4";
export var tableCellClickable = "_5f-5 _5f-4";
export var tableCellDefault = "_5f-6 _5f-4";
export var tableCellEmpty = "_5f-8";
export var tableCellWithValue = "_5f-7";
export var tableContainer = "_5f-e";
export var tableHeaderWeight = "_5f-1";
export var tableHeaderZone = "_5f-2";
export var tableRowHeader = "_5f-3";
export var viewModeButton = "_5f-9";
export var viewModeButtonActive = "_5f-a _5f-9";
export var viewModeButtonInactive = "_5f-b _5f-9";